import { render } from "./PdfUpload.vue?vue&type=template&id=f902746e&scoped=true"
import script from "./PdfUpload.vue?vue&type=script&lang=js"
export * from "./PdfUpload.vue?vue&type=script&lang=js"

import "./PdfUpload.vue?vue&type=style&index=0&id=f902746e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f902746e"]])

export default __exports__